import MarkdownIt from 'markdown-it';
import { MarkdownParser } from 'prosemirror-markdown';
import {
  baseSchemaToMdMapping,
  baseNodesMdToPmMapping,
  baseMarksMdToPmMapping,
  filterMdToPmSchemaMapping,
} from './parser';
import emailMarkdowRules, {
  preserveBlankLinesInCustomTags,
  unwrapCustomTagsFromLinkLabel,
} from './util';

export const messageSchemaToMdMapping = {
  nodes: { ...baseSchemaToMdMapping.nodes },
  marks: { ...baseSchemaToMdMapping.marks },
};

export const messageMdToPmMapping = {
  ...baseNodesMdToPmMapping,
  ...baseMarksMdToPmMapping,
  mention: {
    node: 'mention',
    getAttrs: ({ mention }) => {
      const { userId, userFullName } = mention;
      return { userId, userFullName };
    },
  },
};

const md = MarkdownIt('commonmark', {
  html: false,
  linkify: false,
});

md.enable([
  // Process html entity - &#123;, &#xAF;, &quot;, ...
  'entity',
  // Process escaped chars and hardbreaks
  'escape',
]);

md.disable(['table', 'hr', 'heading', 'lheading'], true);
md.use(emailMarkdowRules);
export class MessageMarkdownTransformer {
  constructor(schema, tokenizer = md) {
    // Enable markdown plugins based on schema
    ['nodes', 'marks'].forEach(key => {
      for (const idx in messageSchemaToMdMapping[key]) {
        if (schema[key][idx]) {
          tokenizer.enable(messageSchemaToMdMapping[key][idx]);
        }
      }
    });

    this.markdownParser = new MarkdownParser(
      schema,
      tokenizer,
      filterMdToPmSchemaMapping(schema, messageMdToPmMapping)
    );
  }

  encode(_node) {
    throw new Error('This is not implemented yet');
  }

  parse(content) {
    const preprocessed = preserveBlankLinesInCustomTags(
      unwrapCustomTagsFromLinkLabel(content)
    );
    return this.markdownParser.parse(preprocessed);
  }
}
